import { z } from 'zod';
import { emailSchema, passwordSchema, personNameSchema, uuidSchema } from './common.js';
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Введите пароль'),
});
/**
 * Регистрация соискателя по пригласительной ссылке.
 * Поля и подсказки повторяют форму из прототипа «соискатель».
 */
export const registerSchema = z.object({
    token: z.string().min(1),
    lastName: personNameSchema,
    firstName: personNameSchema,
    email: emailSchema,
    password: passwordSchema,
});
export const forgotPasswordSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({
    token: z.string().min(1),
    password: passwordSchema,
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, 'Введите текущий пароль'),
    password: passwordSchema,
});
export const updateProfileSchema = z.object({
    lastName: personNameSchema.optional(),
    firstName: personNameSchema.optional(),
    email: emailSchema.optional(),
    /** Телефон, ник в мессенджере — в свободной форме, как человек сам напишет. */
    contact: z.string().trim().max(200).optional(),
    notifyEmail: z.boolean().optional(),
    notifyMessenger: z.boolean().optional(),
});
export const inviteTokenSchema = z.string().min(20).max(200);
/** Срок жизни пригласительной ссылки по умолчанию — неделя. */
export const DEFAULT_INVITE_TTL_HOURS = 168;
/** Потолок — 90 дней: бессрочная ссылка на регистрацию это дыра, а не удобство. */
export const MAX_INVITE_TTL_HOURS = 2160;
/**
 * Ссылку выпускает рекрутёр вместе со встречей либо администратор отдельно,
 * без привязки к встрече — тогда `meetingId` пуст, а срок задаётся вручную.
 */
export const createInviteSchema = z.object({
    meetingId: uuidSchema.optional(),
    ttlHours: z.coerce
        .number()
        .int()
        .min(1)
        .max(MAX_INVITE_TTL_HOURS)
        .default(DEFAULT_INVITE_TTL_HOURS),
    maxUses: z.coerce.number().int().min(1).max(1000).optional(),
    /** Зачем выпущена ссылка — иначе список отдельных ссылок нечитаем. */
    note: z.string().trim().max(200).optional(),
});
/** Готовые варианты срока для выпадающего списка в интерфейсе. */
export const INVITE_TTL_PRESETS = [
    { hours: 24, label: 'Сутки' },
    { hours: 72, label: '3 дня' },
    { hours: 168, label: 'Неделя' },
    { hours: 336, label: '2 недели' },
    { hours: 720, label: 'Месяц' },
];
//# sourceMappingURL=auth.js.map